
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/application/[applicationId]",
      function () {
        return require("private-next-pages/application/[applicationId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/application/[applicationId]"])
      });
    }
  